import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=7d6ef640&scoped=true"
import script from "./TheHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=7d6ef640&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6ef640",
  null
  
)

export default component.exports